import { Button } from "antd";
import { Link, useParams } from "react-router-dom";
import BackButtonIcon from "../../../assets/icons/BackButtonIcon";
import TopCard from "../../../components/common/TopCard";
import JobCard from "../../../components/JobPost/JobCard";
import JobListAndApplied from "../../../components/JobPost/JobListAndApplied";
import Loader from "../../../components/ui/Loader";
import { useGetJobDetailsQuery } from "../../../features/employee/employeeApi";
import useError from "../../../hooks/useError";
import SidebarLayout from "../../../layouts/SidebarLayout";

export type TJobSwitchTab = "DETAILS" | "APPLICANT";

export default function ViewJob() {
  const { id } = useParams();
  const { isLoading, isError, error, data } = useGetJobDetailsQuery(id!, {
    skip: !id,
  });
  useError(isError, error, "Get job details fail");

  const details = data?.data;

  return (
    <SidebarLayout title="Job View">
      <TopCard
        size={16}
        align="center"
        leftChildren={
          <Link to="/admin/recruitment/job-post">
            <Button className="normal-dark-button" icon={<BackButtonIcon />}>
              Back
            </Button>
          </Link>
        }
      >
        {/* <Button icon={<SettingIcon />} type="primary" className="sm-button" /> */}
      </TopCard>

      {isLoading ? (
        <Loader />
      ) : (
        <>
          <JobCard
            companyName={
              details?.company_name || details?.createdByMember?.business?.name!
            }
            available={details?.no_of_vacancies}
            experience={details?.experience_year}
            location={details?.job_location}
            salary={details?.job_salary}
            type={details?.employment_status}
            companyLink={details?.company_website!}
            jobTitle={details?.job_title!}
            jobType={details?.employment_type!}
          />

          <JobListAndApplied data={details} />
        </>
      )}
    </SidebarLayout>
  );
}
